import { Expose, Type } from 'class-transformer';
import { ResourceFloorDto } from './resource-floor.dto';
import { ResourceBuildingDto } from './resource-building.dto';
import { ResourceLocationDto } from './resource-location.dto';
import { ResourcesSpecialPriceResponseDto } from './resources-special-price-response.dto';
import { ResourcesPriceRulesResponseDto } from './resources-price-rules-response.dto';

export class ResourceResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'email' })
  email: string;
  @Expose({ name: 'type' })
  type: string;
  @Expose({ name: 'image' })
  image: string;
  @Expose({ name: 'can_be_booked_by_customer' })
  canBeBookedByCustomer: boolean;
  @Expose({ name: 'is_premium' })
  isPremium: boolean;
  @Expose({ name: 'description' })
  description: string;
  @Expose({ name: 'concurrent_booking' })
  concurrentBooking: number;
  @Expose({ name: 'capacity' })
  capacity: number;
  @Expose({ name: 'available_from' })
  availableFrom: number;
  @Expose({ name: 'available_to' })
  availableTo: number;
  @Expose({ name: 'minimum_booking_time' })
  minimumBookingTime: number;
  @Expose({ name: 'maximum_booking_time' })
  maximumBookingTime: number;
  @Expose({ name: 'pre_booking_days' })
  preBookingDays: number;
  @Expose({ name: 'pre_booking_time' })
  preBookingTime: number;
  @Expose({ name: 'hours_until_booking_allowed' })
  hoursUntilBookingAllowed: number;
  @Expose({ name: 'booking_price' })
  bookingPrice: number;
  @Expose({ name: 'currency' })
  currency: string;
  @Expose({ name: 'policy_id' })
  policyId: number;
  @Expose({ name: 'enable_credit_use' })
  enableCreditUse: boolean;
  @Expose({ name: 'equipment' })
  equipment: string[];
  @Expose({ name: 'available_days' })
  availableDays: number[];
  @Expose({ name: 'location' })
  @Type(() => ResourceLocationDto)
  location: ResourceLocationDto;
  @Expose({ name: 'building' })
  @Type(() => ResourceBuildingDto)
  building: ResourceBuildingDto;
  @Expose({ name: 'floor' })
  @Type(() => ResourceFloorDto)
  floor: ResourceFloorDto;
  @Expose({ name: 'special_prices' })
  @Type(() => ResourcesSpecialPriceResponseDto)
  specialPrices: ResourcesSpecialPriceResponseDto[];
  @Expose({ name: 'pricing_rules' })
  @Type(() => ResourcesPriceRulesResponseDto)
  pricingRules: ResourcesPriceRulesResponseDto[];
}
